import { combineReducers } from 'redux'
import { AddToTrolley, AddToWishlist } from '@sainsburys-tech/bolt'
import CmsReducer from './cms/getContent'
import BrowseSeoReducer from './seo/getBrowseSeo'
import NoResultsReducer from './no-results/getNoResultsContent'
import HookLogic from './hookLogic/hookLogic'
import Category from './category/category'
import Product from './product/product'
import Application from './application/application'

export default function getRootReducer() {
  return combineReducers({
    ...AddToTrolley.reducers,
    ...AddToWishlist.reducers,
    cms: CmsReducer,
    seo: BrowseSeoReducer,
    hookLogic: HookLogic,
    noResults: NoResultsReducer,
    category: Category,
    product: Product,
    application: Application
  })
}
